// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".title-text[data-v-5bc122e9]{margin-top:0;margin-right:10px}.first-button[data-v-5bc122e9]{margin-left:100px}.second-button[data-v-5bc122e9]{margin-left:20px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
